import { IsOptional, IsDate } from "class-validator";

import { IAdapterBacklogRulesSummaryAction } from "./adapter-backlog-rules-summary-action.interface";

export class AdapterBacklogRulesSummaryActionDto
  implements IAdapterBacklogRulesSummaryAction
{
  [s: string]: any;

  @IsOptional()
  @IsDate()
  start_date?: Date;
}
